import {PoweredBy} from "./PoweredBy";
import React from "react";
import {useAppSelector} from "../../app/hooks";
import {hidePoweredBySelector} from "../chatbotSlice";

export const WidgetFooter: React.FC = () => {

    const hidePoweredBy = useAppSelector(hidePoweredBySelector)

    return <>{!hidePoweredBy && <div className="flex justify-center pt-3 pb-1">
        <PoweredBy/>
    </div>}
    </>
}
